const formatLocaleForZendeskDepartment = localeData => {
	if (localeData.length === 5) {
		const locale = `${localeData.substr(0, 2).toLowerCase()}_${localeData.substr(3, 2).toUpperCase()}`;
		return locale;
	}
	return null;
};

export default formatLocaleForZendeskDepartment;
